import { post, get, put } from '../utils/request';

export const road = () => get('/common/sel/road')

export const carType = () => get('/common/sel/car')

export const supplier = () => get('/common/sel/supplier')

export const driver = (data) => get('/common/search/driver')

export const selRole = () => get('/common/sel/role')

